import React from 'react';
import { GetServerSideProps, InferGetServerSidePropsType } from 'next';
import HeadMetaTag from '@/components/metatags/HeadMetaTag';
import FormContato from '@/features/forms/FormContato/FormContato';
import { fetchDataHandler, fetchNavigation } from '@/lib/fetcher';
import { sanitizeQueryParams } from '@/helpers/sanitize';
import { FormContatoProvider } from '@/features/forms/FormContato/context';
import CustomError from '@/features/errors';
import AppProvider from '@/context/AppProvider';

export const getServerSideProps: GetServerSideProps = async ({ req, query }) => {
  const path = `/contato`;
  const [navigation, pageProps] = await Promise.all([
    fetchNavigation(false),
    fetchDataHandler(path, 'FORM CONTATO', req),
  ]);

  let subject, origin, destination;

  subject = (query.subject && sanitizeQueryParams(query.subject, 40)) || null;
  origin = (query.origin && sanitizeQueryParams(query.origin, 40)) || null;
  destination = (query.destination && sanitizeQueryParams(query.destination, 40)) || null;

  const { props, notFound, redirect } = pageProps;
  if (notFound !== undefined) return { notFound: true };
  if (redirect !== undefined) return { redirect };
  if (props !== undefined) {
    let out = {
      ...props,
      navigation,
      params: {
        subject,
        origin,
        destination,
      },
    };

    return { props: out };
  }
  return {
    props: {},
  };
};

const Page = ({ error, data, params, ...props }: InferGetServerSidePropsType<typeof getServerSideProps>) => {
  if (error) {
    return <CustomError error={error} />;
  }

  const { meta } = data;

  return (
    <AppProvider navigation={...props.navigation}>
      <HeadMetaTag meta={meta} />
      <FormContatoProvider data={data} params={params}>
        <FormContato />
      </FormContatoProvider>
    </AppProvider>
  );
};

export default Page;
